import { render, staticRenderFns } from "./ArticleDetailCom.vue?vue&type=template&id=9b3b1972&scoped=true&"
import script from "./ArticleDetailCom.vue?vue&type=script&lang=js&"
export * from "./ArticleDetailCom.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetailCom.vue?vue&type=style&index=0&id=9b3b1972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3b1972",
  null
  
)

export default component.exports